import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { apiCallGetFlaggedConnections } from "../../../api/developer-api/api-call-get-flagged-connections";
import {
  TFlaggedConnectionsDetails,
  TFlaggedConnectionsData,
  TFlaggedConnectionsAll
} from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { reduce } from "et3-type-guards";

class FlaggedConnectionStore {
  flaggedConnectionsData = observable.box<TFlaggedConnectionsData>([]);
  flaggedConnectionsDetails = observable.box<TFlaggedConnectionsDetails>([]);

  setFlaggedConnections = (data: TFlaggedConnectionsAll) => {
    runInAction(() => {
      const flaggedConnectionsData = data.flaggedConnectionsData;
      this.flaggedConnectionsData.set(flaggedConnectionsData);

      const flaggedConnectionsDetails = data.flaggedConnectionsDetails;
      this.flaggedConnectionsDetails.set(flaggedConnectionsDetails);
    });
  };

  getFlaggedConnections = async () => {
    getCoreUIStore().setIsLoading("DEVELOPER_FLAGGED_CONNECTIONS", true);
    const { status, data, code } = await apiCallGetFlaggedConnections();
    getCoreUIStore().setIsLoading("DEVELOPER_FLAGGED_CONNECTIONS", false);
    if (status === "OK") {
      const flaggedConnectionsData = reduce(
        () => data.flaggedConnectionsData,
        []
      );
      const flaggedConnectionsDetails = reduce(
        () => data.flaggedConnectionsDetails,
        []
      );
      this.setFlaggedConnections({
        flaggedConnectionsData,
        flaggedConnectionsDetails
      });
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getFlaggedConnectionStore = memoize(
  () => new FlaggedConnectionStore(),
  () => 1
);
export default getFlaggedConnectionStore;
